module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAAXNSR0IArs4c6QAAAUlJREFUKBWVUT1LA0EQ3bnTQkuJreBPsRERTgQbFRI5EuNHoU0aTYorkkgQC02IRMTPInJEiURUBPE/iFhrKxZamuzOc9dwQaKiDuzHzHvz9rFD89eYhhK9m4OUFf8MJ99IAvRkASKkV2bmAgXoyl90DG+kKAsKnBZA6KNn9gq5+DkjdobSb0IGHy3JklOsYzj/ljMCrZfjl0izRJKZdvscEfOIuN2VB1i3O2pbNdhlUKY215kyHCsgbg1RShB5YHYfqrznA3aAmdP3Yd/tqn0wXNK8QMBgLScmMRE9xZJUnBUQR/09VtgbIOndoOP+UR0qhXFtZvkkZq802c39i4gpu1UkZINXBdNxVzdFXl/UAbMYg6REJWqvfRYw929FDDBVwYJ2tK7H/6wd6AnSoh+xNwzWHj+KGGK4AkfWeUJ/Xbk8SbX25iB/B9XbpbImFOK8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_down.png
// module id = 496
// module chunks = 7